(function () {
  if (window.__IRONSIDE_UGC_CAROUSEL_V24__) return;
  window.__IRONSIDE_UGC_CAROUSEL_V24__ = true;

  function buildIframe(videoId) {
    return '<iframe src="https://www.youtube.com/embed/' +
      videoId +
      '?autoplay=1&playsinline=1&rel=0&modestbranding=1&controls=1&showinfo=0" ' +
      'title="YouTube video" loading="eager" ' +
      'allow="autoplay; encrypted-media; picture-in-picture; clipboard-write; web-share" ' +
      'allowfullscreen></iframe>';
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: 989px)').matches;
  }

  function moveLightboxToBody(section, lightbox) {
    if (!lightbox) return;

    if (!section.dataset.ugcSectionId) {
      section.dataset.ugcSectionId = 'ugc-' + Date.now() + '-' + Math.floor(Math.random() * 100000);
    }

    lightbox.dataset.ugcOwnerId = section.dataset.ugcSectionId;

    if (lightbox.parentNode !== document.body || lightbox !== document.body.lastElementChild) {
      document.body.appendChild(lightbox);
    }

    lightbox.dataset.ugcMovedToBody = 'true';
  }

  function initSection(section, idx) {
    if (!section || section.dataset.ugcReady === 'true') return;
    section.dataset.ugcReady = 'true';

    if (!section.dataset.ugcSectionId) {
      section.dataset.ugcSectionId = 'ugc-' + idx + '-' + Date.now();
    }

    var track = section.querySelector('[data-ironside-ugc-track]');
    var lightbox = section.querySelector('[data-ironside-ugc-lightbox]');
    var videoContainer = lightbox ? lightbox.querySelector('[data-ironside-ugc-lightbox-video]') : null;
    var buttons = Array.prototype.slice.call(section.querySelectorAll('[data-ironside-ugc-open]'));
    var carouselNextBtn = section.querySelector('[data-ironside-ugc-carousel-next]');
    var carouselPrevBtn = section.querySelector('[data-ironside-ugc-carousel-prev]');

    if (!track || !lightbox || !videoContainer || !buttons.length) return;

    moveLightboxToBody(section, lightbox);

    var closes = lightbox.querySelectorAll('[data-ironside-ugc-close]');
    var swipeArea = lightbox.querySelector('[data-ironside-ugc-swipe-area]');
    var nextBtns = lightbox.querySelectorAll('[data-ironside-ugc-next]');
    var prevBtns = lightbox.querySelectorAll('[data-ironside-ugc-prev]');
    var counter = lightbox.querySelector('[data-ironside-ugc-counter]');
    var titleNode = lightbox.querySelector('[data-ironside-ugc-lightbox-title]');

    var currentIndex = 0;
    var swipeThreshold = 50;

    var dragStartX = 0;
    var dragStartY = 0;
    var isDraggingTrack = false;
    var suppressClickUntil = 0;

    var modalStartX = 0;
    var modalStartY = 0;

    var loaderTimeout = null;
    var loaderFallbackTimeout = null;
    var MIN_LOADER_DELAY = 180;
    var MAX_LOADER_VISIBLE_MS = 5000;
    var closeAnimationMs = 250;

    function getLoader() {
      return lightbox.querySelector('[data-ironside-ugc-loader]');
    }

    function clearLoaderTimers() {
      if (loaderTimeout) {
        clearTimeout(loaderTimeout);
        loaderTimeout = null;
      }

      if (loaderFallbackTimeout) {
        clearTimeout(loaderFallbackTimeout);
        loaderFallbackTimeout = null;
      }
    }

    function hideLoader() {
      var loader = getLoader();
      if (loader) loader.classList.remove('active');
    }

    function resetVideoContainer() {
      videoContainer.innerHTML = '<div class="ironside-ugc-loader" data-ironside-ugc-loader><span class="ironside-ugc-spinner"></span></div>';
    }

    function setModalState(open) {
      if (open) {
        document.documentElement.classList.add('ironside-ugc-modal-open');
        document.body.classList.add('ironside-ugc-modal-open');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } else {
        document.documentElement.classList.remove('ironside-ugc-modal-open');
        document.body.classList.remove('ironside-ugc-modal-open');
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
      }
    }

    function normalizeIndex(index) {
      if (index < 0) return buttons.length - 1;
      if (index >= buttons.length) return 0;
      return index;
    }

    function getScrollStep() {
      var firstCard = section.querySelector('[data-ironside-ugc-card]');
      if (!firstCard) return track.clientWidth * 0.8;

      var gap = parseFloat(window.getComputedStyle(track).gap || 0);
      return firstCard.offsetWidth + gap;
    }

    function updateCarouselNextState() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft >= maxScroll - 2;

      if (carouselPrevBtn) carouselPrevBtn.disabled = atStart;
      if (carouselNextBtn) carouselNextBtn.disabled = atEnd;
    }

    function centerCard(index) {
      var btn = buttons[index];
      if (!btn) return;

      var card = btn.closest('[data-ironside-ugc-card]');
      if (!card) return;

      var left = card.offsetLeft;
      var width = card.offsetWidth;
      var target = left - (track.clientWidth / 2) + (width / 2);

      track.scrollTo({
        left: Math.max(0, target),
        behavior: 'smooth'
      });
    }

    function updateCounter() {
      if (!counter) return;
      counter.textContent = (currentIndex + 1) + ' / ' + buttons.length;
    }

    function updateTitle() {
      if (!titleNode) return;
      var title = buttons[currentIndex].getAttribute('data-video-title') || '';
      titleNode.textContent = title;
    }

    function render(index) {
      currentIndex = normalizeIndex(index);

      var id = buttons[currentIndex].getAttribute('data-video-id');

      clearLoaderTimers();
      hideLoader();

      loaderTimeout = setTimeout(function () {
        var delayedLoader = getLoader();
        if (delayedLoader) delayedLoader.classList.add('active');
      }, MIN_LOADER_DELAY);

      resetVideoContainer();
      videoContainer.insertAdjacentHTML('afterbegin', buildIframe(id));

      loaderFallbackTimeout = setTimeout(function () {
        hideLoader();
      }, MAX_LOADER_VISIBLE_MS);

      var iframe = videoContainer.querySelector('iframe');
      if (iframe) {
        iframe.onload = function () {
          clearLoaderTimers();
          hideLoader();
        };
      }

      updateCounter();
      updateTitle();
      centerCard(currentIndex);
    }

    function open(index) {
      moveLightboxToBody(section, lightbox);
      lightbox.hidden = false;
      setModalState(true);
      render(index);

      requestAnimationFrame(function () {
        lightbox.classList.add('active');
      });
    }

    function close() {
      lightbox.classList.remove('active');

      clearLoaderTimers();
      hideLoader();

      setTimeout(function () {
        lightbox.hidden = true;
        resetVideoContainer();
        setModalState(false);
      }, closeAnimationMs);
    }

    function next() {
      render(currentIndex + 1);
    }

    function prev() {
      render(currentIndex - 1);
    }

    buttons.forEach(function (btn, index) {
      btn.addEventListener('click', function (e) {
        if (Date.now() < suppressClickUntil || isDraggingTrack) {
          e.preventDefault();
          return;
        }

        open(index);
      });
    });

    closes.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    nextBtns.forEach(function (btn) {
      btn.addEventListener('click', next);
    });

    prevBtns.forEach(function (btn) {
      btn.addEventListener('click', prev);
    });

    if (carouselPrevBtn) {
      carouselPrevBtn.addEventListener('click', function () {
        track.scrollBy({
          left: getScrollStep() * -2,
          behavior: 'smooth'
        });
      });
    }

    if (carouselNextBtn) {
      carouselNextBtn.addEventListener('click', function () {
        track.scrollBy({
          left: getScrollStep() * 2,
          behavior: 'smooth'
        });
      });
    }

    track.addEventListener('scroll', updateCarouselNextState, { passive: true });
    window.addEventListener('resize', updateCarouselNextState);
    updateCarouselNextState();

    track.addEventListener('touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;

      dragStartX = e.touches[0].clientX;
      dragStartY = e.touches[0].clientY;
      isDraggingTrack = false;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!e.touches || !e.touches.length) return;

      var dx = Math.abs(e.touches[0].clientX - dragStartX);
      var dy = Math.abs(e.touches[0].clientY - dragStartY);

      if (dx > 10 && dx > dy * 1.1) {
        isDraggingTrack = true;
        suppressClickUntil = Date.now() + 250;
      } else if (dy > dx) {
        isDraggingTrack = false;
      }
    }, { passive: true });

    track.addEventListener('touchend', function () {
      setTimeout(function () {
        isDraggingTrack = false;
      }, 50);
    }, { passive: true });

    document.addEventListener('keydown', function (e) {
      if (lightbox.hidden) return;

      if (e.key === 'Escape') close();
      if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next();
      if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') prev();
    });

    if (swipeArea) {
      swipeArea.addEventListener('touchstart', function (e) {
        if (lightbox.hidden || !e.touches || !e.touches.length) return;

        modalStartX = e.touches[0].clientX;
        modalStartY = e.touches[0].clientY;
      }, { passive: true });

      swipeArea.addEventListener('touchend', function (e) {
        if (lightbox.hidden || !e.changedTouches || !e.changedTouches.length) return;

        var endX = e.changedTouches[0].clientX;
        var endY = e.changedTouches[0].clientY;
        var dx = endX - modalStartX;
        var dy = endY - modalStartY;

        if (isMobileViewport()) {
          if (Math.abs(dx) < swipeThreshold || Math.abs(dx) <= Math.abs(dy)) return;

          if (dx < 0) next();
          else prev();
        } else {
          if (Math.abs(dy) < swipeThreshold) return;

          if (dy < 0) next();
          else prev();
        }
      }, { passive: true });
    }

    resetVideoContainer();
    updateTitle();
  }

  function initAll() {
    document.querySelectorAll('[data-ironside-ugc-section]').forEach(function(section, idx) {
      initSection(section, idx);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-ironside-ugc-section]').forEach(function(section, idx) {
      initSection(section, idx);
    });
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target;
    if (!section) return;

    var id = section.dataset ? section.dataset.ugcSectionId : '';
    if (!id) return;

    var movedLightbox = document.querySelector('[data-ugc-owner-id="' + id + '"]');
    if (movedLightbox) movedLightbox.remove();

    document.documentElement.classList.remove('ironside-ugc-modal-open');
    document.body.classList.remove('ironside-ugc-modal-open');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  });
})();
